import * as React from 'react';
import { useFormContext } from 'react-hook-form';
import {
  Box,
  Checkbox,
  FormControlLabel,
  FormGroup,
  FormLabel,
} from '@mui/material';
import { union, filter, findIndex } from 'lodash';
import { useTranslation } from 'react-i18next';

export default function PersonalInfoInput () {
  const { register, setValue, watch } = useFormContext();
  const visitorInfo = watch('visitorInfo', []);
  const visitorInfoHasItem = (name) => findIndex(visitorInfo, (item) => item === name) > -1;
  const visitorMobileSelected = visitorInfoHasItem('phone');
  const changeVisitorItem = (name) => (event) => {
    const checked = event.target.checked;
    if (name === 'phone' && !checked) {
      setValue('visitorInfo', []);
      return;
    }
    if (checked) {
      setValue('visitorInfo', union(visitorInfo, [name]));
    } else {
      setValue('visitorInfo', filter(visitorInfo, (item) => item !== name));
    }
  };
  var [t] = useTranslation();
  return (
    <Box display='flex' flexDirection='column' pt={2}>
      <FormLabel>{t('YBT-ADMIN.YBT-ADMIN-050102.YBT-ADMIN-05010218')}</FormLabel>
      <FormGroup row >
        <FormControlLabel label={t('YBT-ADMIN.YBT-ADMIN-030101.YBT-ADMIN-03010107')} inputRef={register}
          control={<Checkbox color='primary' name='visitorInfo' value='phone'
            onChange={changeVisitorItem('phone')}
          />}
        />
        <FormControlLabel label='Email' inputRef={register}
          disabled={!visitorMobileSelected}
          control={<Checkbox color='primary' name='visitorInfo' value='email'
            onChange={changeVisitorItem('email')}
            checked={visitorInfoHasItem('email')}
          />}
        />
        <FormControlLabel label={t('YBT-ADMIN.YBT-ADMIN-030101.YBT-ADMIN-03010106')} inputRef={register}
          disabled={!visitorMobileSelected}
          control={<Checkbox color='primary' name='visitorInfo' value='name'
            onChange={changeVisitorItem('name')}
            checked={visitorInfoHasItem('name')}
          />}
        />
        <FormControlLabel label={t('YBT-ADMIN.YBT-ADMIN-040401.YBT-ADMIN-04040116')} inputRef={register}
          disabled={!visitorMobileSelected}
          control={<Checkbox color='primary' name='visitorInfo' value='companyName'
            onChange={changeVisitorItem('companyName')}
            checked={visitorInfoHasItem('companyName')}
          />}
        />
        <FormControlLabel label={t('YBT-ADMIN.YBT-ADMIN-050102.YBT-ADMIN-05010223')} inputRef={register}
          disabled={!visitorMobileSelected}
          control={<Checkbox color='primary' name='visitorInfo' value='position'
            onChange={changeVisitorItem('position')}
            checked={visitorInfoHasItem('position')}
          />}
        />
        <FormControlLabel label={t('YBT-ADMIN.YBT-ADMIN-050102.YBT-ADMIN-05010224')} inputRef={register}
          disabled={!visitorMobileSelected}
          control={<Checkbox color='primary' name='visitorInfo' value='industry'
            onChange={changeVisitorItem('industry')}
            checked={visitorInfoHasItem('industry')}
          />}
        />
      </FormGroup>
    </Box>
  );
}
